import React from 'react'
import Main from '../layouts/Main'
import TimeLineList from '../components/TimeLineList'

function TimeLine() {
    return (
        <Main>
            <div className="d-flex align-items-center justify-content-between my-4 page-header-breadcrumb flex-wrap gap-2">
                <div>
                    <p className="fw-semibold fs-20 mb-0">Edit Product</p>
                </div>
            </div>
            <TimeLineList />
        </Main>
    )
}

export default TimeLine